import React from "react";
import { Box, InputAdornment, MenuItem, TextField, Tooltip } from "@mui/material";

export default function RateControlFields({ rateControl, bitrate, maxBitrate, onRateControlChange,
  onBitrateChange, onMaxBitrateChange, disabled = false, errors = {}, range = { min: 1, max: 100000 },
  size }: { rateControl: string; bitrate: string | number; maxBitrate: string | number; onRateControlChange: (v: string) => void; onBitrateChange: (v: string) => void; onMaxBitrateChange: (v: string) => void; disabled?: boolean; errors?: { bitrate?: string; maxBitrate?: string }; range?: { min: number; max: number }; size?: "small" | "medium" }) {
  const isVbr = rateControl === "vbr";
  const bitrateField = (label: string, value: string | number, onChange: (v: string) => void, error: string | undefined, tooltip: string) => (
    <Tooltip title={tooltip} arrow>
      <Box component="span" sx={{ display: "block", minWidth: 0 }}>
        <TextField label={label} value={value} onChange={(event) => onChange(event.target.value)}
          type="number" disabled={disabled} fullWidth size={size} error={Boolean(error)}
          helperText={error || undefined} slotProps={{
            htmlInput: { ...range, step: 1 },
            input: { endAdornment: <InputAdornment position="end">kbps</InputAdornment> },
          }} />
      </Box>
    </Tooltip>
  );

  return <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: isVbr ? "1fr 1fr 1fr" : "1fr 1fr" }, gap: 1.5 }}>
    <TextField select label="Rate control" value={rateControl} onChange={(event) => onRateControlChange(event.target.value)}
      disabled={disabled} fullWidth size={size}>
      <MenuItem value="cbr">CBR</MenuItem>
      <MenuItem value="vbr">VBR</MenuItem>
    </TextField>
    {bitrateField(isVbr ? "Target bitrate" : "Video bitrate", bitrate, onBitrateChange,
      errors.bitrate, `Valid range: ${range.min}-${range.max} kbps.`)}
    {isVbr && bitrateField("Max bitrate", maxBitrate, onMaxBitrateChange,
      errors.maxBitrate, `Maximum VBR bitrate. Valid range: ${range.min}-${range.max} kbps.`)}
  </Box>;
}
